import { render, staticRenderFns } from "./TodosList.vue?vue&type=template&id=78f22436&"
import script from "./TodosList.vue?vue&type=script&lang=js&"
export * from "./TodosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports